import { Text } from "@meditect/medibase-components";

export const DuplicateCodePinError = (): React.ReactElement => {
  return (
    <Text>
      Ce code pin est déjà employé par un autre utilisateur de la pharmacie
    </Text>
  );
};
